import { NgModule } from '@angular/core';
import { ApiService } from "@core/services/api/api.service";
import { ApiSecurityService } from '@core/services/api/api-security.service';

@NgModule({
  providers: [ApiService, ApiSecurityService],
  imports: [],
})

export class ApiModule {};